import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import KanbanSettings from "./KanbanSettings";
import ColorSettings from "./ColorSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import KanbanItemSettings from "./KanbanItemSettings";

const KanbanSettingsModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <KanbanSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.itemSettings" />} key="3">
            <KanbanItemSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.colorSettings" />} key="4">
            <ColorSettings {...props} />
         </TabPane>
      </Tabs>
   );
};
export default KanbanSettingsModal;
